// extracted by mini-css-extract-plugin
module.exports = {"groupWrapper":"ScommesseMarcatoreEsitoOverThreeWithInfoAgg_groupWrapper__C92We","select":"ScommesseMarcatoreEsitoOverThreeWithInfoAgg_select__IGVyY"};